import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_CPT_CODES_BY_TYPE_REQUEST: '',
  GET_CPT_CODES_BY_TYPE_SUCCESS: '',
  GET_CPT_CODES_BY_TYPE_FAILURE: '',

  GET_CPT_CODES_REQUEST: '',
  GET_CPT_CODES_SUCCESS: '',
  GET_CPT_CODES_FAILURE: '',
};

types = setStoreTypeValues(types, 'claimCPTCodes');

export default types;
